import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import { __decorate, __param, __metadata, __awaiter } from '../../_virtual/_tslib.js';
import { HttpClient, HttpMethod } from '@hub-la/fe-core-http-client';
import { inject } from 'inversify';

let GetAddress = class GetAddress {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  execute(postalCode) {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function* () {
      const NON_DIGITS = /\D/g;
      if (postalCode.replace(NON_DIGITS, '').length !== 8) {
        return undefined;
      }
      const response = yield this.httpClient.request({
        method: HttpMethod.GET,
        url: `https://viacep.com.br/ws/${postalCode}/json/`
      });
      const postalCodeData = response.data;
      const address = {
        zip: (_a = postalCodeData.cep) !== null && _a !== void 0 ? _a : '',
        street: (_b = postalCodeData.logradouro) !== null && _b !== void 0 ? _b : '',
        neighborhood: (_c = postalCodeData.bairro) !== null && _c !== void 0 ? _c : '',
        state: (_d = postalCodeData.uf) !== null && _d !== void 0 ? _d : '',
        city: (_e = postalCodeData.localidade) !== null && _e !== void 0 ? _e : '',
        country: 'BR'
      };
      return address;
    });
  }
};
GetAddress = __decorate([__param(0, inject(HttpClient)), __metadata("design:paramtypes", [HttpClient])], GetAddress);

export { GetAddress };
